import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { DEFAULT_REACT_USE_QUERY_OPTIONS } from "../constants"
import { PaginatedResponseMini } from "../interfaces/baseInterfaces"
import { ApiManager } from "../api/ApiManager"
import { ISubscriptionPack } from "../interfaces/api/sms/packs"
import { ITaskCategory } from "../interfaces/ITask"

export const COMMON_REACT_QUERY_KEYS = {
	useAllTaskCategoriesQuery: "allTaskCategoriesQuery",
	useAllSubscriptionPacksQuery: "allSubscriptionPacksQuery",
}

export const useAllTaskCategoriesQuery = (includeInactive?: boolean, options?: UseQueryOptions<PaginatedResponseMini<ITaskCategory>>) => {
	return useQuery({
        queryKey: ["allTaskCategoriesQuery"],
        queryFn: () => ApiManager.getShifuServiceApis().getAllTaskCategories(),
        ...DEFAULT_REACT_USE_QUERY_OPTIONS,
        ...options
    });
}

export const useAllSubscriptionPacksQuery = (
	limit?: number,
	offset?: number,
	sort?: {
		sortBy: string
		sortOrder: "ASC" | "DESC"
	},
	options?: UseQueryOptions<PaginatedResponseMini<ISubscriptionPack>>
) => {
	return useQuery({
        queryKey: ["allSubscriptionPacksQuery", limit, offset, sort],
        queryFn: () => ApiManager.getSubscriptionManagerApis().getAllPacks(limit, offset, sort),
        ...DEFAULT_REACT_USE_QUERY_OPTIONS,
        ...options
    });
}
